/* istanbul ignore file */

export var FREE_UK_DELIVERY = 'Free UK Delivery';